<template>
  <cvc-view>
    <div class="advertising-wrapper">
      <advertising-tool-bar />
      <v-container>
        <router-view />
      </v-container>
    </div>
  </cvc-view>
</template>

<script>
import CvcView from "@/components/CvcView";
import AdvertisingToolBar from "@/components/AdvertisingToolBar";
export default {
  name: "Advertising",
  components: { AdvertisingToolBar, CvcView },
};
</script>

<style scoped>
.advertising-wrapper {
  /* margin: 10px;
   background-color: #F1F1F1;
   padding: 24px 16px;
   border: 0.3px black solid; */
}
</style>
